import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
// import { HelperService } from '../shared/helper/helper.service';
import { Router } from '@angular/router';
import { HelperService } from 'src/app/shared/services/helper.service';
import { APIRequestService } from 'src/app/shared/services/api/apirequest.service';
import { APIURLTypes } from 'src/app/shared/enums/apiurltypes.enum';
import { apiUrlparts } from 'src/app/shared/enums/apiurlparts.const';
import { environment } from 'src/environments/environment';
import { log } from 'util';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  private controller = 'http://23.98.216.140:9992/api/auth/';

  constructor(
    private httpClient: HttpClient,
    private helperService: HelperService,
    private router: Router
  ) { }

  getHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = this.helperService.token.get(); // this.userInfoService.getStoredToken();
    headers = headers.append('Content-Type', 'application/json');
    if (token !== null) {
      headers = headers.append('Authorization', 'Bearer ' + token);
    }
    return headers;
  }

  login(formData: any): Observable<object> {
    return this.httpClient.post<object>(this.controller + 'login', formData);
  }
  logout() {
    this.logoutAPI();
  }

  getUserPermissionsbyIAMCode(code) {
    return this.httpClient.get<object>(environment.iamhost + 'arya/token?code=' + code);
  }

  logoutAPI() {
    return this.httpClient.post<object>(environment.iamhost + 'arya/token?code=', null);
  }
}
